import React from 'react';
import GeoDataRenderer from './geoDataRenderer';
import MetricColumnRenderer from './metricColumnRenderer';

const columns: any = [
  {
    title: '',
    key: 'metrics',
    dataKey: 'metrics',
    width: 100,
    maxWidth: 110,
    resizable: true,
    align: 'left',
    frozen: 'left',
    cellRenderer: ({ cellData }) => (
      <MetricColumnRenderer
        cellData={cellData}
      />
    ),
  },
  {
    title: 'Session',
    key: 'session',
    dataKey: 'session',
    width: 90,
    maxWidth: 100,
    resizable: true,
    align: 'left',
    cellRenderer: ({ cellData }) => (
      <GeoDataRenderer
        cellData={cellData}
      />
    ),
  },
  {
    title: 'City',
    key: 'city',
    dataKey: 'city',
    width: 90,
    maxWidth: 100,
    resizable: true,
    align: 'left',
    cellRenderer: ({ cellData }) => (
      <GeoDataRenderer
        cellData={cellData}
      />
    ),
  },
  {
    title: 'ASN',
    key: 'asn',
    dataKey: 'asn',
    width: 90,
    maxWidth: 100,
    resizable: true,
    align: 'left',
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <GeoDataRenderer
        cellData={cellData}
      />
    ),
  },
];

export default columns;
